module.exports = __webpack_public_path__ + "img/sticker_1.2099a6df.svg";